import { httpsCallable } from "firebase/functions";
import { Functions } from "./firebase";

export async function authWithHash(userId, hash) {
  const authWithHashFunction = httpsCallable(Functions, "authWithHash");
  const result = await authWithHashFunction({ userId, hash });

  // @ts-ignore
  return result.data?.result;
}